// Minimal shared constants for Business Data service types / auth methods used
// by the bring-your-own-app OAuth flows (Salesforce, HubSpot). Mirrors the
// API's business-data-service-registry.
export const Services = {
  Salesforce: 'salesforce',
  HubSpot: 'hubspot',
} as const;

// Services whose wizard authenticates through the per-tenant OAuth popup.
export const OAUTH_SERVICES: readonly string[] = [Services.Salesforce, Services.HubSpot];

export const AuthMethods = {
  OAuth2: 'oauth2',
} as const;
